const config = {
  SERVICE_CLOUD_URL: "https://service.maropost-staging.com/",
  MAROPOST_IDENTITY_BASE_URL: "https://id-staging.maropost.com",

  API_BASE_URL: "https://service-staging.maropost.com/api/v1/service",

  //API_BASE_URL: "https://beta-web.maropost.com/api/v1/service",

  domain: "service.maropost-staging.com",

  INVALIDDOMAINS: [
    "yopmail.com",
    "optonline.net",
    "juno.com",
    "shaw.ca",
    "yahoo.ca",
    "me.com",
    "btinternet.com",
    "gmx.de",
    "charter.net",
    "web.de",
    "earthlink.net",
    "ymail.com",
    "yahoo.co.uk",
    "hotmail.co.uk",
    "cox.net",
    "bellsouth.net",
    "live.com",
    "att.net",
    "verizon.net",
    "sbcglobal.net",
    "msn.com",
    "comcast.net",
    "aol.com",
    "hotmail.com",
    "yahoo.com",
    "gmail.com",
  ],
};

const env = window.location.host.replace('.maropost.com','')

switch(env){
  case 'app': 
    config.API_BASE_URL = "https://servicecloud.maropost.com/api/v1/service"
    break;
  case 'sandbox': 
    config.API_BASE_URL = "https://service-sandbox.maropost.com/api/v1/service"
    break;
  case 'uat': 
    config.API_BASE_URL = "https://service-uat.maropost.com/api/v1/service"
    break;
}

export default config;